import React from 'react';

import { ShaxmatkaContext } from '../context';

export const useShaxmatka = () => {
  const data = React.useContext(ShaxmatkaContext);

  if (!data) {
    throw new Error('useShaxmatka must be used within a ShaxmatkaProvider');
  }

  return data;
};
